import { v4 as uuid } from 'uuid';
import { map } from 'lodash';
import { toUUID } from '../../util/transform';
import type { ICommissionSplit } from './CommissionSplit.interface';

export default class CommissionSplit implements ICommissionSplit {
  id: string;
  idPayee: string;
  payeeType: string;
  upfront: number;
  upfrontPercentage: number;
  trail: number;
  trailPercentage: number;
  splits: Array<CommissionSplit>;
  name: string;
  isRemainder: boolean;
  isActive: boolean;

  getName() {
    return this.name;
  }

  getUpfront() {
    return this.upfront;
  }

  getUpfrontPercentage() {
    return this.upfrontPercentage;
  }

  getTrail() {
    return this.trail;
  }

  getTrailPercentage() {
    return this.trailPercentage;
  }

  static build = (data: ICommissionSplit) => new CommissionSplit(data);
  static blank = () => new CommissionSplit();

  /**
   * Constructor
   * @param {ICommissionSplit} data
   */
  constructor(data?: ICommissionSplit) {
    this.id = toUUID(data?.id) || uuid();
    this.idPayee = toUUID(data?.idPayee) || data?.idPayee || '';
    this.payeeType = data?.payeeType || '';
    this.upfront = parseFloat(data?.upfront || 0);
    this.upfrontPercentage = parseFloat(data?.upfrontPercentage || 0);
    this.trail = parseFloat(data?.trail || 0);
    this.trailPercentage = parseFloat(data?.trailPercentage || 0);
    this.splits = map(data?.splits, (obj) => new CommissionSplit(obj));
    this.name = data?.name || '';
    this.isRemainder = data?.isRemainder === true;
    this.isActive = data?.isActive === true;
  }
}
